import { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { ChevronDown, Eye, Loader2, Send } from 'lucide-react';
import { Button } from '../ui/button';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Şablonu örnek firma verileriyle gerçek e-posta görünümünde gösterir ve test e-postası gönderir
export const TemplatePreview = ({ subject, body, testId }) => {
  const [open, setOpen] = useState(false);
  const [preview, setPreview] = useState(null);
  const [sending, setSending] = useState(false);

  useEffect(() => {
    if (!open) return undefined;
    const t = setTimeout(() => {
      axios.post(`${API}/settings/email-template/preview`, { subject, body }).then(res => setPreview(res.data)).catch(() => setPreview(null));
    }, 350);
    return () => clearTimeout(t);
  }, [open, subject, body]);

  const sendTest = async () => {
    setSending(true);
    try {
      const res = await axios.post(`${API}/settings/email-template/test`, { subject, body });
      toast.success(res.data.message);
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Test e-postası gönderilemedi');
    } finally { setSending(false); }
  };

  return (
    <div className="rounded-lg border bg-slate-50/60" data-testid={`template-preview-${testId}`}>
      <button type="button" onClick={() => setOpen(o => !o)} className="w-full flex items-center gap-1.5 px-3 py-2 text-xs font-medium text-slate-600 hover:text-slate-900" data-testid={`template-preview-toggle-${testId}`}>
        <Eye className="h-3.5 w-3.5" />Önizleme (örnek firma verileriyle)
        <ChevronDown className={`h-3.5 w-3.5 ml-auto transition-transform ${open ? 'rotate-180' : ''}`} />
      </button>
      {open && (
        <div className="px-3 pb-3 space-y-2">
          {!preview ? <Loader2 className="h-4 w-4 animate-spin text-slate-400" /> : (
            <>
              <p className="text-xs text-slate-500">Konu: <span className="font-medium text-slate-800" data-testid={`template-preview-subject-${testId}`}>{preview.subject}</span></p>
              <iframe title="E-posta önizleme" srcDoc={preview.html} sandbox="" className="w-full h-72 rounded border bg-white" data-testid={`template-preview-frame-${testId}`} />
            </>
          )}
          <Button type="button" size="sm" variant="outline" onClick={sendTest} disabled={sending} data-testid={`template-test-send-${testId}`}>
            {sending ? <Loader2 className="h-3.5 w-3.5 mr-1 animate-spin" /> : <Send className="h-3.5 w-3.5 mr-1" />}Bana Test E-postası Gönder
          </Button>
          <p className="text-[11px] text-slate-500">Kaydetmeden, ekrandaki son hâli giriş yaptığınız e-posta adresine "[TEST]" etiketiyle gönderilir.</p>
        </div>
      )}
    </div>
  );
};
